import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var WifiOn = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.885 18.185C38.98 11.41 31.005 7 22 7 12.994 7 5.02 11.409.113 18.185l1.434 1.434C6.072 13.196 13.545 9 22 9c8.454 0 15.928 4.196 20.453 10.619l1.433-1.434Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M38.85 23.221C35.294 17.677 29.076 14 22 14c-7.079 0-13.297 3.677-16.85 9.221L6.6 24.673C9.758 19.472 15.474 16 21.999 16c6.526 0 12.241 3.472 15.399 8.673l1.451-1.452Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M33.714 28.357A12.999 12.999 0 0 0 22 21a12.999 12.999 0 0 0-11.715 7.357l1.515 1.515A10.999 10.999 0 0 1 22 23a10.999 10.999 0 0 1 10.199 6.872l1.515-1.515Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M26 34a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }));
});
WifiOn.displayName = 'WifiOn';
WifiOn.defaultProps = {
  'aria-label': 'WifiOn'
};
export default WifiOn;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/WifiOn.js
// module id = 3959
// module chunks = 11